// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MapModal_wrapper__3TUV1","map":"MapModal_map__ruauS","google":"MapModal_google__2EXTV","text":"MapModal_text__11xax"};